"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const models_1 = require("../model/models");
let defaultBasePath = 'http://localhost:3000';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
var ChainRoutesApiApiKeys;
(function (ChainRoutesApiApiKeys) {
})(ChainRoutesApiApiKeys = exports.ChainRoutesApiApiKeys || (exports.ChainRoutesApiApiKeys = {}));
class ChainRoutesApi {
    constructor(basePathOrUsername, password, basePath) {
        this._basePath = defaultBasePath;
        this._defaultHeaders = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };
        this._useQuerystring = false;
        if (password) {
            if (basePath) {
                this.basePath = basePath;
            }
        }
        else {
            if (basePathOrUsername) {
                this.basePath = basePathOrUsername;
            }
        }
    }
    set useQuerystring(value) {
        this._useQuerystring = value;
    }
    set basePath(basePath) {
        this._basePath = basePath;
    }
    set defaultHeaders(defaultHeaders) {
        this._defaultHeaders = defaultHeaders;
    }
    get defaultHeaders() {
        return this._defaultHeaders;
    }
    get basePath() {
        return this._basePath;
    }
    combineHeaders(reqOptions) {
        return reqOptions ? Object.assign(Object.assign({}, this._defaultHeaders), reqOptions.headers) : this._defaultHeaders;
    }
    /**
     * Returns the current height of the blockchain.
     * @summary Get the current height of the chain
     */
    getBlockchainHeight(reqOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const localVarPath = '/chain/height';
            let requestHeaders = this.combineHeaders(reqOptions);
            let localVarRequestOptions = {
                method: 'GET',
                headers: requestHeaders,
                url: localVarPath,
                baseURL: this.basePath,
                responseType: 'json'
            };
            return new Promise((resolve, reject) => {
                axios_1.default(localVarRequestOptions).then((response) => {
                    let body = models_1.ObjectSerializer.deserialize(response.data, "HeightInfoDTO");
                    if (response.status && response.status >= 200 && response.status <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject(response);
                    }
                }, (error) => {
                    reject(error);
                });
            });
        });
    }
    /**
     * Gets the current score of the blockchain. The higher the score, the better the chain. During synchronization, nodes try to get the best blockchain in the network.  The score for a block is derived from its difficulty and the time (in seconds) that has elapsed since the last block:      block score = difficulty − time elapsed since last block
     * @summary Get the current score of the chain
     */
    getBlockchainScore(reqOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const localVarPath = '/chain/score';
            let requestHeaders = this.combineHeaders(reqOptions);
            let localVarRequestOptions = {
                method: 'GET',
                headers: requestHeaders,
                url: localVarPath,
                baseURL: this.basePath,
                responseType: 'json'
            };
            return new Promise((resolve, reject) => {
                axios_1.default(localVarRequestOptions).then((response) => {
                    let body = models_1.ObjectSerializer.deserialize(response.data, "BlockchainScoreDTO");
                    if (response.status && response.status >= 200 && response.status <= 299) {
                        resolve({ response: response, body: body });
                    }
                    else {
                        reject(response);
                    }
                }, (error) => {
                    reject(error);
                });
            });
        });
    }
}
exports.ChainRoutesApi = ChainRoutesApi;
//# sourceMappingURL=chainRoutesApi.js.map